export default function InfoIcon() {
  return (
    <>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3ZM12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4Z"
          fill="white"
        />
        <path
          d="M12.5 15.5L12.5 11.112L11.5249 11.112L11.5249 15.5L12.5 15.5Z"
          fill="white"
        />
        <path
          d="M12.5 9.64935L12.5 8.67425L11.5249 8.67425L11.5249 9.64935L12.5 9.64935Z"
          fill="white"
        />
      </svg>
    </>
  );
}
